<div class="flex flex-col gap-3">
    <span class="font-bold text-xl" i18n>Product</span>
    <span i18n>Optionally, select the product you want to import the identification no. for.</span>

    <ng-container [ngSwitch]="service.productStepStatus()">
        <div class="flex justify-center py-10" *ngSwitchCase="'loading'">
            <div class="spinner spinner-primary spinner-xl"></div>
        </div>

        <div class="alert alert-error shadow-lg" *ngSwitchCase="'error'">
            <div class="w-full flex flex-row gap-4">
                <iota-icon icon="information-circle" size="1.5"></iota-icon>
                <span i18n>Error loading products!</span>
                <div class="flex-1"></div>
                <button class="btn btn-primary" (click)="service.reloadProducts()" i18n>Reload products</button>
            </div>
        </div>

        <span *ngSwitchCase="'empty'" i18n>No products found.</span>

        <div class="w-full flex flex-row justify-center my-5" *ngSwitchCase="'ready'">
            <select
                class="select select-bordered w-full max-w-md"
                data-testid="smartAssistantProductSelect"
                (change)="updateProduct($event)"
            >
                <option value="" [selected]="!service.selectedProductId()" i18n>Detect automatically</option>
                <option
                    *ngFor="let option of service.productOptions()"
                    [value]="option.id"
                    [selected]="option.id === service.selectedProductId()"
                >
                    {{ option.label }}
                </option>
            </select>
        </div>
    </ng-container>

    <span i18n
        >If no product is selected, it is determined automatically for each employee. This requires the employee to have exactly one active
        subscription to a product of this solution partner on the day of the import. Otherwise, the product must be selected.</span
    >
</div>
